import clsx from 'clsx';
import React, { FC } from 'react';

import { SIZES } from '../../../../core/constants';
import { HeaderRowHeadlineTotal } from './headers/header-row-headline-total';
import { getRowHeight, getWrapperStyle } from './style-rows';
import { TotalRow } from './types';

import grid from '../../../../ui/data-grid/components/grid.scss';
import { PredictionsSubCategories } from '../../../../core/types';
import { usePredictionsInfoContext } from '../../context/predictions-info-context';

interface Props {
  totalRows: TotalRow[] | null;
  rowSize?: SIZES;
  categoryOptions?: { name: string; value: PredictionsSubCategories }[];
}

export const HeaderRows: FC<Props> = ({ totalRows, categoryOptions, rowSize = SIZES.LARGE }) => {
  const { rowHeaderWidth } = usePredictionsInfoContext();

  const rowHeaderWrapperClasses = clsx({
    [grid.rowHeaderWrapper]: true,
    [grid.hasScrolled]: true
  });

  const getRowStyle = (index: number, totalRow: TotalRow) => ({
    ...getWrapperStyle(index, {}, rowSize, totalRow, true),
    height: getRowHeight(index, { default: rowSize }, totalRow, true)
  });

  return (
    <div className={rowHeaderWrapperClasses} style={{ width: rowHeaderWidth }}>
      {totalRows?.map((totalRow, index) => (
        <HeaderRowHeadlineTotal
          key={`${totalRow.account?.index || totalRow.section}_total_header`}
          level={0}
          totalRow={{
            ...totalRow,
            account: { ...totalRow.account, name: (totalRow?.name as string) || 'no-name' },
            isMainHeadline: true
          }}
          wrapperStyle={getRowStyle(index, totalRow)}
          categoryOptions={categoryOptions}
        />
      ))}
    </div>
  );
};
